import vs from './project2.vertex.glsl';
export default {
  name: 'project2',
  vs: vs,
  fs: vs
};
//# sourceMappingURL=project2.js.map